import update from 'immutability-helper'

let eventBusHandler = null;

const LaneHelper = {
  initialiseLanes: (state, { lanes, boardId, eventBusHandle }) => {
    eventBusHandler = eventBusHandle;
    const newLanes = lanes && lanes.map(lane => {
      lane.currentPage = 1
      lane.cards && lane.cards.forEach(function (c) {
        if (c) {
          c.laneId = lane._id;
          c.boardId = boardId;
        }

      })
      return lane
    });
    return update(state, { lanes: { $set: newLanes } })
  },

  paginateLane: (state, { laneId, newCards, nextPage }) => {
    const updatedLanes = LaneHelper.appendCardsToLane(state, { laneId: laneId, newCards: newCards })
    updatedLanes.find(lane => lane._id === laneId).currentPage = nextPage
    return update(state, { lanes: { $set: updatedLanes } })
  },

  appendCardsToLane: (state, { laneId, newCards, index }) => {
    const lane = state.lanes.find(lane => lane._id === laneId);
    newCards = newCards
      .map(c => update(c, { laneId: { $set: laneId } }));
    return state.lanes.map(lane => {
      if (lane._id === laneId) {
        if (index !== undefined) {
          const cardsToUpdate = [...lane.cards]
          cardsToUpdate.splice(index, 0, ...newCards);
          return update(lane, { cards: { $set: cardsToUpdate } })
        } else {
          const cardsToUpdate = [...lane.cards, ...newCards]
          cardsToUpdate.forEach(function (card, cardIndex) {
            card._id = card._id;
          });
          return update(lane, { cards: { $set: cardsToUpdate } })
        }
      } else {
        return lane
      }
    })
  },

  appendCardToLane: (state, { laneId, card, index }) => {
    const newLanes = LaneHelper.appendCardsToLane(state, { laneId: laneId, newCards: [card], index })
    return update(state, { lanes: { $set: newLanes } })
  },

  removeCardFromLane: (state, { laneId, cardId }) => {

    const lanes = state.lanes.map(lane => {
      if (lane._id === laneId) {
        let newCards = lane.cards.filter(card => card._id !== cardId)
        return update(lane, { cards: { $set: newCards } })
      } else {
        return lane
      }
    })
    return update(state, { lanes: { $set: lanes } })
  },

  moveCardAcrossLanes: (state, { type, data, fromBoardId, fromLaneId, toBoardId, toLaneId, cardId, index, communityTagColor, duration }) => {

    if (fromBoardId === toBoardId) {

      const interimLanes = state.lanes.map(lane => {
        if (lane._id === fromLaneId) {
          const newCards = lane.cards.filter(card => card && card._id !== cardId)
          return update(lane, { cards: { $set: newCards } })
        } else {
          return lane
        }
      })

      const updatedState = update(state, { lanes: { $set: interimLanes } })
      const cardToMove = eventBusHandler[fromBoardId].publish({ type: 'GET_CARD', laneId: fromLaneId, cardId: cardId });
      const cardToMoveCopy = cardToMove[0];
      cardToMoveCopy.laneId = toLaneId;
      cardToMoveCopy.communityTagColor = communityTagColor;
      cardToMoveCopy.duration = duration;
      cardToMoveCopy.parentActivity = toLaneId;
      return LaneHelper.appendCardToLane(updatedState, { laneId: toLaneId, card: cardToMoveCopy, index: index })
    } else {
      if (type === "activity") {
        const cardToMove1 = {
          boardId: toBoardId,
          id: cardId,
          laneId: toLaneId,
          title: data,
          communityTagColor: communityTagColor
        }
        return LaneHelper.appendCardToLane(state, { laneId: toLaneId, card: cardToMove1, index: index })

      } else {
        if (eventBusHandler && eventBusHandler[fromBoardId]) {
          const cardToMove = eventBusHandler[fromBoardId].publish({ type: 'GET_CARD', laneId: fromLaneId, cardId: cardId });


          const cardToMoveCopy = cardToMove[0];
          cardToMoveCopy.boardId = toBoardId;
          cardToMoveCopy.laneId = toLaneId;
          cardToMoveCopy.communityTagColor = communityTagColor;
          cardToMoveCopy.duration = duration;
          cardToMoveCopy.parentActivity = toLaneId;

          eventBusHandler[fromBoardId].publish({ type: 'REMOVE_CARD', laneId: fromLaneId, cardId: cardId });
          return LaneHelper.appendCardToLane(state, { laneId: toLaneId, card: cardToMoveCopy, index: index })
        } else {
          return state;
        }
      }
    }

  },

  updateCardsForLane: (state, { laneId, cards }) => {
    const lanes = state.lanes.map(lane => {
      if (lane._id === laneId) {
        return update(lane, { cards: { $set: cards } })
      } else {
        return lane
      }
    })
    return update(state, { lanes: { $set: lanes } })
  },

  updateLanes: (state, lanes) => {
    return { ...state, ...{ lanes: lanes } }
  },

  moveLane: (state, { oldIndex, newIndex }) => {
    const laneToMove = state.lanes[oldIndex]
    const tempState = update(state, { lanes: { $splice: [[oldIndex, 1]] } });
    return update(tempState, { lanes: { $splice: [[newIndex, 0, laneToMove]] } })
  }
}
export default LaneHelper